import React from "react";

const Experience = () => {
    return (
       <div className="experience">
           <div className="d-flex justify-content-center my-5">
               <h1>experience</h1>

           </div>
           <div className="container experience-wrapper">
               <div className="timeline-block timeline-block-right">
                   <div className="marker"></div>
                   <div className="timeline-content">
                       <h3>2017</h3>
                       <p> Intrashare:
                        Intrashare is an application which share the files without internet.

                       </p>
                   </div>
               </div>

               <div className="timeline-block timeline-block-left">
                   <div className="marker"></div>
                   <div className="timeline-content">
                       <h3>2018</h3>
                       <p>Augmented Reality based app: gives the detail about faculty when we placed mobile camera on nameplate of faculty

                           
                       </p>
                   </div>
               </div>

               <div className="timeline-block timeline-block-right">
                   <div className="marker"></div>
                   <div className="timeline-content">
                       <h3>2020</h3>
                       <p>Burger builder app let you to choose ingredients and purchase burger
                           
                       </p>
                   </div>
               </div>

               <div className="timeline-block timeline-block-left">
                   <div className="marker"></div>
                   <div className="timeline-content">
                       <h3>2021</h3>
                       <p>portfolio app which is different and unique with design and little bit animations

                           
                       </p>
                   </div>
               </div>

               <div className="timeline-block timeline-block-right">
                   <div className="marker"></div>
                   <div className="timeline-content">
                       <h3>2022</h3>
                       <p>E-Commerce (Amazon Clone) website
                           
                       </p>
                   </div>
               </div>

           </div>
       </div>
    )
}

export default Experience
